let rx = {};
rx.list = {};

rx.on = function(key, fun) {
    if (!this.list[key]) {
        this.list[key] = [];
    }
    this.list[key].push(fun);
};

rx.emit = function() {
    let key = Array.prototype.shift.call(arguments);
    let funs = this.list[key];
    if (!funs || funs.length === 0) {
        return;
    }
    funs.forEach(fun => {
        fun.apply(this, arguments);
    });
};

rx.remove = function(key, fun) {
    let funs = this.list[key];
    if (!funs) return false;

    if (!fun) {
        funs && (funs.length = 0);
    } else {
        funs.forEach((cb, i) => {
            if (cb === fun) {
                funs.splice(i, 1);
            }
        });
    }
};

export default rx;
